require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[62],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(520);


/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _TextArea = _interopRequireDefault(__webpack_require__(521));

exports["default"] = _TextArea["default"];
exports.TextArea = _TextArea["default"];

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _baUiCarbon = __webpack_require__(12);

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var sanitize = _utils.propsUtils.sanitize,
    BaPropTypes = _utils.propsUtils.BaPropTypes;

var TextArea = /*#__PURE__*/function (_PureComponent) {
  (0, _inheritsLoose2["default"])(TextArea, _PureComponent);

  function TextArea() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "ref", _react["default"].createRef());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChange", function (e) {
      var value = e.target.value;
      _this.props.onChange && _this.props.onChange(value, e);
    });
    return _this;
  }

  var _proto = TextArea.prototype;

  _proto.focus = function focus() {
    var node = this.ref.current;
    node.focus();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        fireOnBlur = _this$props.fireOnBlur,
        disabled = _this$props.disabled,
        light = _this$props.light,
        readOnly = _this$props.readOnly,
        placeholder = _this$props.placeholder,
        value = _this$props.value,
        rows = _this$props.rows,
        resize = _this$props.resize,
        dir = _this$props.dir,
        textDir = _this$props.textDir,
        validationErrorText = _this$props.validationErrorText,
        hasValidationError = _this$props.hasValidationError,
        className = _this$props.className,
        style = _this$props.style,
        labelText = _this$props.labelText,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["fireOnBlur", "disabled", "light", "readOnly", "placeholder", "value", "rows", "resize", "dir", "textDir", "validationErrorText", "hasValidationError", "className", "style", "labelText"]);
    var cProps = {
      value: value,
      placeholder: placeholder,
      disabled: disabled,
      light: light,
      readOnly: readOnly,
      'aria-readonly': readOnly,
      rows: rows,
      onChange: this._onChange,
      invalid: hasValidationError,
      invalidText: validationErrorText,
      ref: this.ref,
      labelText: labelText || ''
    };
    return /*#__PURE__*/_react["default"].createElement(_baUiCarbon.TextArea, (0, _extends2["default"])({
      className: className,
      "data-tid": "textArea"
    }, sanitize(others, _baUiCarbon.TextArea), cProps));
  };

  return TextArea;
}(_react.PureComponent);

exports["default"] = TextArea;
(0, _defineProperty2["default"])(TextArea, "propTypes", {
  /** Specify the placeholder attribute for the <textarea> */
  placeholder: _propTypes["default"].string,

  /** Specify the rows attribute for the <textarea> */
  rows: _propTypes["default"].number,

  /** Provide the current value of the <textarea> */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Specify the disabled attribute for the <textarea> */
  disabled: _propTypes["default"].bool,

  /** Specify the readOnly attribute for the <textarea> */
  readOnly: _propTypes["default"].bool,
  // Carbon light variant of the component
  light: _propTypes["default"].bool,

  /** Deprecated - is ignored and not applicable to carbon select */
  resize: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Deprecated - is ignored and not applicable to carbon select */
  fireOnBlur: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Optionally provide an `onChange` handler that is called whenever <textarea>is updated */
  onChange: _propTypes["default"].func,

  /** Deprecated - is ignored and not applicable to carbon select */
  dir: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Deprecated - is ignored and not applicable to carbon select */
  textDir: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Provide the text that is displayed when the control is in an invalid state */
  validationErrorText: _propTypes["default"].string,

  /** Provide a custom className that is applied directly to the underlying <textarea> node */
  className: _propTypes["default"].string,

  /** Deprecated - is ignored and not applicable to carbon select */
  style: BaPropTypes.deprecated(' is ignored and not applicable to carbon select'),

  /** Specify whether the control is currently invalid */
  hasValidationError: _propTypes["default"].bool,

  /** Provide the text for a label and that will be read by a screen reader when visiting this control */
  labelText: _propTypes["default"].string
});
(0, _defineProperty2["default"])(TextArea, "defaultProps", {
  className: ''
});

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ })

},[[519,0]]]);
});